import React, { ChangeEvent, useMemo, useState } from "react";
import { InputAdornment, Paper, Stack, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";

import Chip from "components/uiElements/dataDisplay/Chip";
import { Tag } from "./TagManagementPage";

interface TagListProps {
  onClick(tag: Tag): void;
  selectedTags?: Array<Tag>;
  tags: Array<Tag>;
}

export default function TagList(props: TagListProps): React.JSX.Element {
  const { i18n } = useTranslation();

  const [search, setSearch] = useState<string>("");

  const filteredTags = useMemo(() => {
    return props.tags.filter((tag) => tag.name.toLowerCase().includes(search.toLowerCase()));
  }, [props.tags, search]);

  const selectedTags = props.selectedTags ?? [];

  return (
    <Stack
      direction="column"
      sx={{
        gap: 1,
        width: "220px"
      }}>
      <Paper sx={{ p: 1, ml: 0, mr: 1, mb: 1, position: "sticky", top: "0px", zIndex: 1200}}>
        <Stack direction="column" sx={{
          gap: 1
        }} >
          <TextField
            autoComplete="off"
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              setSearch(event.target.value);
            }}
            placeholder={i18n.t("tag-list.field-search-placeholder")}
            size="small"
            slotProps={{
              input: {
                startAdornment: <InputAdornment position="start"><SearchIcon/></InputAdornment>
              }
            }}
            sx={{minWidth: 128}}
            value={search}
          />
          {filteredTags.map((tag, index) => {
            const isSelected = !!selectedTags.find((t) => t.id === tag.id);
            return (
              <Chip
                color={isSelected ? tag.color : ""}
                fullWidth={true}
                key={`TagList.Tags.${tag.id}`}
                label={tag.name}
                onClick={() => props.onClick(tag)}
                selected={isSelected}
              />
            );
          })}
        </Stack>
      </Paper>
    </Stack>
  );
}